import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';
import { EventType } from '../../../types';

interface StyleProps {
  offeringType: EventType;
  disabled?: boolean;
}
interface OfferingStatusStyleProps {
  isFullyBooked: boolean;
  isBooked: boolean;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme: ITheme) => ({
  content: {
    padding: '24px 0',
    height: 'calc(100% - 69px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  chip: {
    marginRight: 8,
    marginBottom: 8,
    borderRadius: 20,
    backgroundColor: ({ offeringType }) => theme.eventColors[offeringType],
    paddingLeft: 16,
    paddingRight: 16,
  },
  detailsChip: {
    marginRight: 8,
    marginBottom: 8,
    borderRadius: 20,
    paddingLeft: 16,
    paddingRight: 16,
  },
  topicsLabel: {
    color: colors.darkGray,
    fontWeight: 700,
    paddingBottom: 8,
    paddingTop: 24,
  },
  button: {
    color: colors.darkestBlue,
    fontWeight: 700,
    width: '70%',
    alignSelf: 'center',
  },
  recommended: {
    textAlign: 'center',
    background: colors.secondaryLightGreen,
    border: `1px solid ${colors.secondaryDarkGreen}`,
    margin: '0 -24px -14px -24px',
    boxSizing: 'content-box',
    height: 42,
    paddingTop: 14,
    borderRadius: '16px 16px 0px 0px',
    fontWeight: 'bold',
    fontSize: 14,
    color: colors.secondaryDarkGreen,
  },
  hide: {
    visibility: 'hidden',
  },
}));

export const useOfferingStatusStyles = makeStyles<
  ITheme,
  OfferingStatusStyleProps
>((theme: ITheme) => ({
  statusBanner: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8.5,
    zIndex: 1,
    bottom: 0,
    width: '100%',
    height: 50,
    background: ({ isFullyBooked }) =>
      isFullyBooked ? colors.midYellow : colors.lightGreen,
    fontSize: 14,
    borderRadius: '0px 0px 16px 16px',
    [theme.breakpoints.up('sm')]: {
      width: '350px',
    },
  },
  statusCta: {
    color: colors.darkestBlue,
    textDecoration: 'none',
    fontWeight: 700,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
